import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedKpiData: {}
};

// Config slice
export const kpiSlice = createSlice({
  name: 'kpiSlice',
  initialState,
  reducers: {
    selectedKpi: (state, action) => {
      state.selectedKpiData = action?.payload;
    }
  }
});

// Export actions
export const { selectedKpi } = kpiSlice.actions;
// Export reducer
export const { reducer: kpiReducer } = kpiSlice;
